
const digest = '4a3ef3203684b53ff36c02747fe35237c58110249681ac45458cd8aae7eceb13';
const classes = {"item":"_item_14w3t_1","title":"_title_14w3t_8","buttons":"_buttons_14w3t_18"};
const css = `._item_14w3t_1 {
  font-family: Rubik, sans-serif;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  margin-bottom: 10px;
}

._title_14w3t_8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px;
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
}

._buttons_14w3t_18 {
  display: flex;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  